<template>
  <div class="_content">
    <section class="year-record">
      <!-- 背景图 -->
      <img class="bg" src="https://res.xiaokunkeji.cn/image/2023/12/14/e41a13db2d4b41f181bff1e5aa73a44e.png" alt=""
        srcset="" />
      <section class="page-content">
        <RecordList :dataList="dataList" :tabList="tabList" @goPage="goPage">
          <template #top>
            <section class="check-block">
              <span>{{ queryYear }}年</span>
              <div class="img" @click="change" v-if="yearList.length">
                <img src="https://res.xiaokunkeji.cn/image/2023/12/14/3b171fa3213d4eb79958069853792c0e.png" alt="" />
              </div>
              <div class="year-list" :style="{ display: isOpen ? 'block' : 'none' }">
                <div v-for="item in yearList" :key="item" @click="oncheck(item)"
                  :style="{ background: queryYear === item ? '#f5f5f5' : '' }">
                  {{ item }}
                </div>
              </div>
            </section>
          </template>
        </RecordList>
      </section>
    </section>
  </div>
</template>

<script>
import RecordList from "./components/list.vue";
import config from '@/configs/config';
import moment from 'moment';
export default {
  components: { RecordList },
  data() {
    return {
      dataList: [],
      tabList: {
        verifyOrderSum: {
          num: 0,
          text: "核销订单数",
          icon: "https://res.xiaokunkeji.cn/image/2023/12/14/50fa1f29610e4cfaa9074e811fcd18e9.png",
        },
        orderAmountSum: {
          num: 0,
          text: "核销订单总收入",
          icon: "https://res.xiaokunkeji.cn/image/2023/12/14/4360a3f7855d4483bcd3d25d3e4060e2.png",
        },
      },
      queryYear: "", //查询的年份
      isOpen: false, //年份选择
      yearList: [], //年份选择列表
    };
  },
  mounted() {
    this.handleYear();
    this.shopId=tuhu.getParam("shopId")||JSON.parse(localStorage.getItem("_xk_user_key"))['shopId']
    this.queryDataList()
  },
  methods: {
    //前往月记录
    goPage(row) {
      tuhu.navigateTo({
        url: `/pages/monthRecord/index?date=${row.month}&shopId=${this.shopId}`,
      });
      // localStorage.setItem('monthList',JSON.stringify(row))
    },
    //展开收起年份选择
    change() {
      this.isOpen = !this.isOpen;
    },
    //选择年份查询
    oncheck(row) {
      this.queryYear = row;
      this.queryDataList()
      this.isOpen = false;
    },
    //处理可选年份数据
    handleYear() {
      this.yearList = [];
      this.queryYear = new Date().getFullYear();//"2025-12-13"
      //2023年起始，当年与2023年相差几年
      let subtractNum = this.queryYear - 2023;
      if (subtractNum === 0) return;
      for (let i = 0; i <= subtractNum; i++) {
        let temp = 2023 + i;
        this.yearList.push(temp);
      }
    },
    //获取列表数据
    async queryDataList() {
      tuhu.showIndicator()
      this.dataList=[]
      const res = await tuhu.fetch(`${config.apis.GET_TIKTOK_ORDER_YEAR_RECORD}?shopId=${this.shopId}&year=${this.queryYear}`);
      tuhu.hideIndicator();
      if (res && res.code === '200') {
        this.tabList['verifyOrderSum']['num']=(res['data']&&res['data']['verifyOrderSum'])||0
        this.tabList['orderAmountSum']['num']=(res['data']&&res['data']['orderAmountSum'])||0
        this.dataList=res&&res.data&&res.data.monthList.length?res.data.monthList.map(item=>{
          item.count=item.verifyOrderSum;
          item.date=moment(item.month).format("YYYY年MM月")
          item.price = item.orderAmountSum;
          return item
        }):[]
      } else {
        tuhu.toast(res.message || "网络错误");
      }
    },
  },
};
</script>
<style lang="less" scoped>
._content {
  background: #f8f9fb;

  .year-record {
    .bg {
      width: 100%;
      height: 14.85rem;
    }

    .page-content {
      .check-block {
        display: flex;
        align-items: center;
        position: relative;

        .img {
          padding: 0.25rem;

          >img {
            width: 0.6rem;
            height: 0.3rem;
          }
        }

        .year-list {
          position: absolute;
          right: left;
          top: 1.4rem;
          background: #ffffff;
          width: 4.6rem;
          border-radius: 0.1rem;
          width: 4rem;
          line-height: 1.5rem;
          box-shadow: 0rem 0.1rem 0.2rem 0rem #f1f1f1;
          color: #333;
          font-size: 0.8rem;
          max-height: 5.5rem;
          overflow: scroll;

          >div {
            height: 1.5rem;
            text-align: center;
            // background: #f5f5f5;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/record/year.vue